import { render, staticRenderFns } from "./PainelDestinatariosEtapa.vue?vue&type=template&id=71c4b9c5&scoped=true"
import script from "./PainelDestinatariosEtapa.vue?vue&type=script&lang=js"
export * from "./PainelDestinatariosEtapa.vue?vue&type=script&lang=js"
import style0 from "./PainelDestinatariosEtapa.vue?vue&type=style&index=0&id=71c4b9c5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71c4b9c5",
  null
  
)

export default component.exports